import {
  VIEW_WREG_DETAILS,
  VIEW_WREG_HEALTH_CHECK,
  VIEW_WREG_PROGRAMS,
  VIEW_WREG_TERMS,
  VIEW_WREG_SWITCH_CONSENT,
  VIEW_WREG_LAB_RESULTS,
  VIEW_WREG_SHIPPING,
  VIEW_WREG_ALL_SET,
  VIEW_WREG_NOT_ELIGIBLE,
  VIEW_WREG_ALREADY_ENROLLED,
  VIEW_WREG_CONTROL_GROUP,
  VIEW_WREG_CONFIRM_DETAILS,
  VIEW_WREG_NO_QUALIFYING_CONDITION,
  VIEW_WREG_ERROR,
  VIEW_WREG_SWITCH_COMPLETE,
  VIEW_WREG_OUTREACH,
  VIEW_WREG_LABS_PENDING,
  VIEW_WREG_DECLINED,
} from '@/consts/events';
import type { WregStep } from '@/components/webreg/wregSteps';

export const WREG_VIEW: Record<WregStep, string> = {
  intake: VIEW_WREG_DETAILS,
  screener: VIEW_WREG_HEALTH_CHECK,
  tracks: VIEW_WREG_PROGRAMS,
  agreement: VIEW_WREG_TERMS,
  switch: VIEW_WREG_SWITCH_CONSENT,
  labs: VIEW_WREG_LAB_RESULTS,
  monitor: VIEW_WREG_SHIPPING,
  allset: VIEW_WREG_ALL_SET,
  'x-notelig': VIEW_WREG_NOT_ELIGIBLE,
  'x-already': VIEW_WREG_ALREADY_ENROLLED,
  'x-control': VIEW_WREG_CONTROL_GROUP,
  'x-mismatch': VIEW_WREG_CONFIRM_DETAILS,
  'x-noqualify': VIEW_WREG_NO_QUALIFYING_CONDITION,
  'x-error': VIEW_WREG_ERROR,
  'x-switchok': VIEW_WREG_SWITCH_COMPLETE,
  'x-outreach': VIEW_WREG_OUTREACH,
  'x-labspending': VIEW_WREG_LABS_PENDING,
  'x-declined': VIEW_WREG_DECLINED,
};
